// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: qtWvXH8Uhh67sc1TY2MZeK
// Component: O5iATX6f5QtD

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Logo from "../../Logo"; // plasmic-import: RkBFuHrIeu0V/component
import TextInput from "../../TextInput"; // plasmic-import: emBFV5U9rqD2/component
import Button from "../../Button"; // plasmic-import: 5mSzAv6LmD41/component
import { Fetcher } from "@plasmicapp/react-web/lib/data-sources";

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: ROqE-xVeeGeS/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import projectcss from "./plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import sty from "./PlasmicSignInSignUpForm.module.css"; // plasmic-import: O5iATX6f5QtD/css

import SearchsvgIcon from "./icons/PlasmicIcon__Searchsvg"; // plasmic-import: dnXZ1c5WXZwi/icon
import IconsCloseIcon from "./icons/PlasmicIcon__IconsClose"; // plasmic-import: X64Nn1RksJUu/icon
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: 4aDWqHkWfWe2/icon
import Icon6Icon from "./icons/PlasmicIcon__Icon6"; // plasmic-import: uyexNrJzq8td/icon
import BlackDividerIcon from "./icons/PlasmicIcon__BlackDivider"; // plasmic-import: pj35VY-AS-65/icon
import Ellipse15Icon from "./icons/PlasmicIcon__Ellipse15"; // plasmic-import: o-I89RxVMT4u/icon
import XLogoIcon from "./icons/PlasmicIcon__XLogo"; // plasmic-import: ptP4Yvb7Sdub/icon
import ArrowReply24FilledIcon from "./icons/PlasmicIcon__ArrowReply24Filled"; // plasmic-import: tVyHbsM0xE8i/icon

createPlasmicElementProxy;

export type PlasmicSignInSignUpForm__VariantMembers = {
  mode: "signIn" | "signUp" | "magic";
  app: "hubHub" | "mapMap";
};
export type PlasmicSignInSignUpForm__VariantsArgs = {
  mode?: SingleChoiceArg<"signIn" | "signUp" | "magic">;
  app?: SingleChoiceArg<"hubHub" | "mapMap">;
};
type VariantPropType = keyof PlasmicSignInSignUpForm__VariantsArgs;
export const PlasmicSignInSignUpForm__VariantProps = new Array<VariantPropType>(
  "mode",
  "app"
);

export type PlasmicSignInSignUpForm__ArgsType = {
  email?: string;
  emailError?: React.ReactNode;
  passwordError?: React.ReactNode;
  nameError?: React.ReactNode;
  authUrl?: string;
};
type ArgPropType = keyof PlasmicSignInSignUpForm__ArgsType;
export const PlasmicSignInSignUpForm__ArgProps = new Array<ArgPropType>(
  "email",
  "emailError",
  "passwordError",
  "nameError",
  "authUrl"
);

export type PlasmicSignInSignUpForm__OverridesType = {
  root?: p.Flex<"div">;
  container?: p.Flex<"div">;
  logoAndText?: p.Flex<"div">;
  logo?: p.Flex<typeof Logo>;
  form?: p.Flex<"div">;
  top?: p.Flex<"div">;
  proProLabel?: p.Flex<"div">;
  topContent?: p.Flex<"div">;
  space?: p.Flex<"div">;
  loginTable?: p.Flex<"form">;
  nameField?: p.Flex<"div">;
  nameInput?: p.Flex<typeof TextInput>;
  emailField?: p.Flex<"div">;
  emailInput?: p.Flex<typeof TextInput>;
  passwordField?: p.Flex<"div">;
  passwordInput?: p.Flex<typeof TextInput>;
  signInButton?: p.Flex<typeof Button>;
  space2?: p.Flex<"div">;
  orSignUpSignInWithOneOfTheseSocialNetworks?: p.Flex<"div">;
  signInPlatformsButtons?: p.Flex<"div">;
  facebookAuthButton?: p.Flex<"button">;
  blackButtonFrame?: p.Flex<"div">;
  iconSourcesFacebook?: p.Flex<"div">;
  xcomAuthButton?: p.Flex<"button">;
  blackButtonFrame2?: p.Flex<"div">;
  googleAuthButton?: p.Flex<"button">;
  blackButtonFrame3?: p.Flex<"div">;
  space3?: p.Flex<"div">;
  dontLikePasswordsMaybeAPasswordManagerIsWhatYouNeedButYouCanAlso?: p.Flex<"div">;
  space4?: p.Flex<"div">;
  magicLinkSignInButton?: p.Flex<typeof Button>;
  span?: p.Flex<"span">;
  resetPassword?: p.Flex<"div">;
  andIfYouNeedToYouCan?: p.Flex<"div">;
  resetPasswordButton?: p.Flex<"a">;
  signInContainer?: p.Flex<"div">;
  andIfYouNeedToYouCan2?: p.Flex<"div">;
  resetPasswordButton2?: p.Flex<"a">;
  space5?: p.Flex<"div">;
  bottom?: p.Flex<"div">;
  orSignUpButton?: p.Flex<"div">;
  buttonDefault?: p.Flex<"div">;
  continueWithoutAnAccountButton?: p.Flex<typeof Button>;
};

export interface DefaultSignInSignUpFormProps {
  email?: string;
  emailError?: React.ReactNode;
  passwordError?: React.ReactNode;
  nameError?: React.ReactNode;
  authUrl?: string;
  mode?: SingleChoiceArg<"signIn" | "signUp" | "magic">;
  app?: SingleChoiceArg<"hubHub" | "mapMap">;
  className?: string;
}

const $$ = {};

function PlasmicSignInSignUpForm__RenderFunc(props: {
  variants: PlasmicSignInSignUpForm__VariantsArgs;
  args: PlasmicSignInSignUpForm__ArgsType;
  overrides: PlasmicSignInSignUpForm__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          email: ""
        },
        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "mode",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.mode
      },
      {
        path: "variable",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "nameInput.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "emailInput.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "passwordInput.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "app",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.app
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        sty.root,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.rootapp_hubHub]: hasVariant($state, "app", "hubHub"),
          [sty.rootapp_mapMap]: hasVariant($state, "app", "mapMap"),
          [sty.rootmode_magic]: hasVariant($state, "mode", "magic"),
          [sty.rootmode_signIn]: hasVariant($state, "mode", "signIn"),
          [sty.rootmode_signUp]: hasVariant($state, "mode", "signUp")
        }
      )}
    >
      <p.Stack
        as={"div"}
        data-plasmic-name={"container"}
        data-plasmic-override={overrides.container}
        hasGap={true}
        className={classNames(projectcss.all, sty.container, {
          [sty.containermode_magic]: hasVariant($state, "mode", "magic"),
          [sty.containermode_signIn]: hasVariant($state, "mode", "signIn"),
          [sty.containermode_signUp]: hasVariant($state, "mode", "signUp")
        })}
      >
        <div
          data-plasmic-name={"logoAndText"}
          data-plasmic-override={overrides.logoAndText}
          className={classNames(projectcss.all, sty.logoAndText, {
            [sty.logoAndTextapp_mapMap]: hasVariant($state, "app", "mapMap"),
            [sty.logoAndTextmode_signUp]: hasVariant($state, "mode", "signUp")
          })}
        >
          <p.PlasmicImg
            alt={""}
            className={classNames(sty.img__t4Xg1, {
              [sty.imgapp_mapMap__t4Xg1DtoEa]: hasVariant(
                $state,
                "app",
                "mapMap"
              )
            })}
            displayHeight={"auto"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"auto"}
            loader={"plasmic"}
            loading={"lazy"}
            src={{
              src: "https://img.plasmic.app/img-optimizer/v1/img/49814fa12d9e8a3ad2ccc7bf5c3883cc.png",
              fullWidth: 474,
              fullHeight: 111
            }}
          />

          <Logo
            data-plasmic-name={"logo"}
            data-plasmic-override={overrides.logo}
            app={hasVariant($state, "app", "mapMap") ? "mapMap" : "hubHub"}
            className={classNames("__wab_instance", sty.logo, {
              [sty.logoapp_mapMap]: hasVariant($state, "app", "mapMap")
            })}
            size={"medium"}
          />
        </div>
        <p.Stack
          as={"div"}
          data-plasmic-name={"form"}
          data-plasmic-override={overrides.form}
          hasGap={true}
          className={classNames(projectcss.all, sty.form, {
            [sty.formmode_signIn]: hasVariant($state, "mode", "signIn"),
            [sty.formmode_signUp]: hasVariant($state, "mode", "signUp")
          })}
        >
          <div
            data-plasmic-name={"top"}
            data-plasmic-override={overrides.top}
            className={classNames(projectcss.all, sty.top, {
              [sty.topmode_signUp]: hasVariant($state, "mode", "signUp")
            })}
          >
            <div
              data-plasmic-name={"proProLabel"}
              data-plasmic-override={overrides.proProLabel}
              className={classNames(projectcss.all, sty.proProLabel, {
                [sty.proProLabelmode_signUp]: hasVariant(
                  $state,
                  "mode",
                  "signUp"
                )
              })}
            >
              <p.PlasmicImg
                alt={""}
                className={classNames(sty.img__rF4Sv, {
                  [sty.imgmode_signUp__rF4SvDiTvY]: hasVariant(
                    $state,
                    "mode",
                    "signUp"
                  )
                })}
                displayHeight={"auto"}
                displayMaxHeight={"none"}
                displayMaxWidth={"80%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"auto"}
                loader={"plasmic"}
                loading={"lazy"}
                src={{
                  src: "https://img.plasmic.app/img-optimizer/v1/img/cb3d3b338ec5803af231c89faf80d8f0.png",
                  fullWidth: 984,
                  fullHeight: 110
                }}
              />
            </div>
            <p.Stack
              as={"div"}
              data-plasmic-name={"topContent"}
              data-plasmic-override={overrides.topContent}
              hasGap={true}
              className={classNames(projectcss.all, sty.topContent, ``, {
                [sty.topContentmode_magic]: hasVariant($state, "mode", "magic"),
                [sty.topContentmode_signIn]: hasVariant(
                  $state,
                  "mode",
                  "signIn"
                ),
                [sty.topContentmode_signUp]: hasVariant(
                  $state,
                  "mode",
                  "signUp"
                )
              })}
            >
              <div
                data-plasmic-name={"space"}
                data-plasmic-override={overrides.space}
                className={classNames(projectcss.all, sty.space)}
              />

              <p.Stack
                as={"form"}
                data-plasmic-name={"loginTable"}
                data-plasmic-override={overrides.loginTable}
                hasGap={true}
                className={classNames(projectcss.all, sty.loginTable, {
                  [sty.loginTablemode_signIn]: hasVariant(
                    $state,
                    "mode",
                    "signIn"
                  ),
                  [sty.loginTablemode_signUp]: hasVariant(
                    $state,
                    "mode",
                    "signUp"
                  )
                })}
              >
                {(hasVariant($state, "mode", "signUp") ? true : false) ? (
                  <p.Stack
                    as={"div"}
                    data-plasmic-name={"nameField"}
                    data-plasmic-override={overrides.nameField}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.nameField, {
                      [sty.nameFieldmode_signUp]: hasVariant(
                        $state,
                        "mode",
                        "signUp"
                      )
                    })}
                  >
                    <TextInput
                      data-plasmic-name={"nameInput"}
                      data-plasmic-override={overrides.nameInput}
                      className={classNames("__wab_instance", sty.nameInput, {
                        [sty.nameInputmode_signUp]: hasVariant(
                          $state,
                          "mode",
                          "signUp"
                        )
                      })}
                      context={"signInSignUpForm"}
                      onChange={(...eventArgs) => {
                        p.generateStateOnChangeProp($state, [
                          "nameInput",
                          "value"
                        ])((e => e.target?.value).apply(null, eventArgs));
                      }}
                      placeholder={"name"}
                      value={
                        p.generateStateValueProp($state, [
                          "nameInput",
                          "value"
                        ]) ?? ""
                      }
                    />
                  </p.Stack>
                ) : null}
                {(hasVariant($state, "mode", "signUp") ? true : false)
                  ? p.renderPlasmicSlot({
                      defaultContents: null,
                      value: args.nameError
                    })
                  : null}
                <p.Stack
                  as={"div"}
                  data-plasmic-name={"emailField"}
                  data-plasmic-override={overrides.emailField}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.emailField, {
                    [sty.emailFieldmode_magic]: hasVariant(
                      $state,
                      "mode",
                      "magic"
                    ),
                    [sty.emailFieldmode_signIn]: hasVariant(
                      $state,
                      "mode",
                      "signIn"
                    ),
                    [sty.emailFieldmode_signUp]: hasVariant(
                      $state,
                      "mode",
                      "signUp"
                    )
                  })}
                >
                  <TextInput
                    data-plasmic-name={"emailInput"}
                    data-plasmic-override={overrides.emailInput}
                    className={classNames("__wab_instance", sty.emailInput, {
                      [sty.emailInputmode_signIn]: hasVariant(
                        $state,
                        "mode",
                        "signIn"
                      ),
                      [sty.emailInputmode_signUp]: hasVariant(
                        $state,
                        "mode",
                        "signUp"
                      )
                    })}
                    context={"signInSignUpForm"}
                    onChange={async (...eventArgs: any) => {
                      ((...eventArgs) => {
                        p.generateStateOnChangeProp($state, [
                          "emailInput",
                          "value"
                        ])((e => e.target?.value).apply(null, eventArgs));
                      }).apply(null, eventArgs);
                      (async event => {
                        const $steps = {};

                        $steps["updateVariable"] = true
                          ? (() => {
                              const actionArgs = {
                                variable: {
                                  objRoot: $state,
                                  variablePath: ["variable"]
                                },
                                operation: 0
                              };
                              return (({
                                variable,
                                value,
                                startIndex,
                                deleteCount
                              }) => {
                                if (!variable) {
                                  return;
                                }
                                const { objRoot, variablePath } = variable;

                                p.set(objRoot, variablePath, value);
                                return value;
                              })?.apply(null, [actionArgs]);
                            })()
                          : undefined;
                        if (
                          $steps["updateVariable"] != null &&
                          typeof $steps["updateVariable"] === "object" &&
                          typeof $steps["updateVariable"].then === "function"
                        ) {
                          $steps["updateVariable"] = await $steps[
                            "updateVariable"
                          ];
                        }
                      }).apply(null, eventArgs);
                    }}
                    placeholder={"email"}
                    type={"text"}
                    value={
                      p.generateStateValueProp($state, [
                        "emailInput",
                        "value"
                      ]) ?? ""
                    }
                  />
                </p.Stack>
                {p.renderPlasmicSlot({
                  defaultContents: null,
                  value: args.emailError
                })}
                <p.Stack
                  as={"div"}
                  data-plasmic-name={"passwordField"}
                  data-plasmic-override={overrides.passwordField}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.passwordField, {
                    [sty.passwordFieldmode_magic]: hasVariant(
                      $state,
                      "mode",
                      "magic"
                    ),
                    [sty.passwordFieldmode_signIn]: hasVariant(
                      $state,
                      "mode",
                      "signIn"
                    ),
                    [sty.passwordFieldmode_signUp]: hasVariant(
                      $state,
                      "mode",
                      "signUp"
                    )
                  })}
                >
                  <TextInput
                    data-plasmic-name={"passwordInput"}
                    data-plasmic-override={overrides.passwordInput}
                    className={classNames("__wab_instance", sty.passwordInput, {
                      [sty.passwordInputmode_magic]: hasVariant(
                        $state,
                        "mode",
                        "magic"
                      ),
                      [sty.passwordInputmode_signIn]: hasVariant(
                        $state,
                        "mode",
                        "signIn"
                      ),
                      [sty.passwordInputmode_signUp]: hasVariant(
                        $state,
                        "mode",
                        "signUp"
                      )
                    })}
                    context={"signInSignUpForm"}
                    onChange={(...eventArgs) => {
                      p.generateStateOnChangeProp($state, [
                        "passwordInput",
                        "value"
                      ])((e => e.target?.value).apply(null, eventArgs));
                    }}
                    placeholder={"password"}
                    type={
                      hasVariant($state, "mode", "signUp")
                        ? "password"
                        : hasVariant($state, "mode", "signIn")
                        ? "password"
                        : "password"
                    }
                    value={
                      p.generateStateValueProp($state, [
                        "passwordInput",
                        "value"
                      ]) ?? ""
                    }
                  />
                </p.Stack>
                {(hasVariant($state, "mode", "magic") ? false : true)
                  ? p.renderPlasmicSlot({
                      defaultContents: null,
                      value: args.passwordError
                    })
                  : null}
                <Button
                  data-plasmic-name={"signInButton"}
                  data-plasmic-override={overrides.signInButton}
                  className={classNames("__wab_instance", sty.signInButton, {
                    [sty.signInButtonmode_magic]: hasVariant(
                      $state,
                      "mode",
                      "magic"
                    ),
                    [sty.signInButtonmode_signIn]: hasVariant(
                      $state,
                      "mode",
                      "signIn"
                    ),
                    [sty.signInButtonmode_signUp]: hasVariant(
                      $state,
                      "mode",
                      "signUp"
                    )
                  })}
                  color={"lightBlue"}
                  size={"compact"}
                  submitsForm={true}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__iSkZv,
                      {
                        [sty.textmode_magic__iSkZvz7Brm]: hasVariant(
                          $state,
                          "mode",
                          "magic"
                        ),
                        [sty.textmode_signUp__iSkZvDiTvY]: hasVariant(
                          $state,
                          "mode",
                          "signUp"
                        )
                      }
                    )}
                  >
                    {hasVariant($state, "mode", "magic")
                      ? "Send Magic Link"
                      : hasVariant($state, "mode", "signUp")
                      ? "Sign Up"
                      : "Sign In"}
                  </div>
                </Button>
              </p.Stack>
              <div
                data-plasmic-name={"space2"}
                data-plasmic-override={overrides.space2}
                className={classNames(projectcss.all, sty.space2)}
              />

              <BlackDividerIcon
                className={classNames(projectcss.all, sty.svg__q9Gh9)}
                role={"img"}
              />

              <div
                data-plasmic-name={"orSignUpSignInWithOneOfTheseSocialNetworks"}
                data-plasmic-override={
                  overrides.orSignUpSignInWithOneOfTheseSocialNetworks
                }
                className={classNames(
                  projectcss.all,
                  sty.orSignUpSignInWithOneOfTheseSocialNetworks
                )}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__yYutg,
                    {
                      [sty.textmode_signUp__yYutgdiTvY]: hasVariant(
                        $state,
                        "mode",
                        "signUp"
                      )
                    }
                  )}
                >
                  {"Or sign up / sign in with one of these social networks"}
                </div>
              </div>
              <p.Stack
                as={"div"}
                data-plasmic-name={"signInPlatformsButtons"}
                data-plasmic-override={overrides.signInPlatformsButtons}
                hasGap={true}
                className={classNames(
                  projectcss.all,
                  sty.signInPlatformsButtons,
                  {
                    [sty.signInPlatformsButtonsmode_signIn]: hasVariant(
                      $state,
                      "mode",
                      "signIn"
                    )
                  }
                )}
              >
                <button
                  data-plasmic-name={"facebookAuthButton"}
                  data-plasmic-override={overrides.facebookAuthButton}
                  className={classNames(
                    projectcss.all,
                    projectcss.button,
                    sty.facebookAuthButton,
                    {
                      [sty.facebookAuthButtonmode_magic]: hasVariant(
                        $state,
                        "mode",
                        "magic"
                      ),
                      [sty.facebookAuthButtonmode_signIn]: hasVariant(
                        $state,
                        "mode",
                        "signIn"
                      ),
                      [sty.facebookAuthButtonmode_signUp]: hasVariant(
                        $state,
                        "mode",
                        "signUp"
                      )
                    }
                  )}
                  ref={ref => {
                    $refs["facebookAuthButton"] = ref;
                  }}
                >
                  <div
                    data-plasmic-name={"blackButtonFrame"}
                    data-plasmic-override={overrides.blackButtonFrame}
                    className={classNames(
                      projectcss.all,
                      sty.blackButtonFrame,
                      {
                        [sty.blackButtonFramemode_magic]: hasVariant(
                          $state,
                          "mode",
                          "magic"
                        ),
                        [sty.blackButtonFramemode_signIn]: hasVariant(
                          $state,
                          "mode",
                          "signIn"
                        ),
                        [sty.blackButtonFramemode_signUp]: hasVariant(
                          $state,
                          "mode",
                          "signUp"
                        )
                      }
                    )}
                  />

                  <div
                    data-plasmic-name={"iconSourcesFacebook"}
                    data-plasmic-override={overrides.iconSourcesFacebook}
                    className={classNames(
                      projectcss.all,
                      sty.iconSourcesFacebook
                    )}
                  >
                    <Ellipse15Icon
                      className={classNames(projectcss.all, sty.svg__tYfub)}
                      role={"img"}
                    />

                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__rQ3Ez, {
                        [sty.imgmode_signIn__rQ3Ezamtuw]: hasVariant(
                          $state,
                          "mode",
                          "signIn"
                        )
                      })}
                      displayHeight={"36.603px"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"33.788px"}
                      loader={"plasmic"}
                      loading={"lazy"}
                      src={{
                        src: "https://site-assets.plasmic.app/5a9931d936645dac5b47fae5e32bf478.svg",
                        fullWidth: 33.788,
                        fullHeight: 36.603,
                        aspectRatio: 0.918919
                      }}
                    />
                  </div>
                </button>
                <button
                  data-plasmic-name={"xcomAuthButton"}
                  data-plasmic-override={overrides.xcomAuthButton}
                  className={classNames(
                    projectcss.all,
                    projectcss.button,
                    sty.xcomAuthButton,
                    {
                      [sty.xcomAuthButtonmode_signIn]: hasVariant(
                        $state,
                        "mode",
                        "signIn"
                      )
                    }
                  )}
                  ref={ref => {
                    $refs["xcomAuthButton"] = ref;
                  }}
                >
                  <div
                    data-plasmic-name={"blackButtonFrame2"}
                    data-plasmic-override={overrides.blackButtonFrame2}
                    className={classNames(
                      projectcss.all,
                      sty.blackButtonFrame2,
                      {
                        [sty.blackButtonFrame2mode_signIn]: hasVariant(
                          $state,
                          "mode",
                          "signIn"
                        ),
                        [sty.blackButtonFrame2mode_signUp]: hasVariant(
                          $state,
                          "mode",
                          "signUp"
                        )
                      }
                    )}
                  />

                  <XLogoIcon
                    className={classNames(projectcss.all, sty.svg__rYpli, {
                      [sty.svgmode_signIn__rYpliAmtuw]: hasVariant(
                        $state,
                        "mode",
                        "signIn"
                      ),
                      [sty.svgmode_signUp__rYpliDiTvY]: hasVariant(
                        $state,
                        "mode",
                        "signUp"
                      )
                    })}
                    role={"img"}
                  />
                </button>
                <button
                  data-plasmic-name={"googleAuthButton"}
                  data-plasmic-override={overrides.googleAuthButton}
                  className={classNames(
                    projectcss.all,
                    projectcss.button,
                    sty.googleAuthButton,
                    {
                      [sty.googleAuthButtonmode_magic]: hasVariant(
                        $state,
                        "mode",
                        "magic"
                      ),
                      [sty.googleAuthButtonmode_signIn]: hasVariant(
                        $state,
                        "mode",
                        "signIn"
                      ),
                      [sty.googleAuthButtonmode_signUp]: hasVariant(
                        $state,
                        "mode",
                        "signUp"
                      )
                    }
                  )}
                  ref={ref => {
                    $refs["googleAuthButton"] = ref;
                  }}
                >
                  <div
                    data-plasmic-name={"blackButtonFrame3"}
                    data-plasmic-override={overrides.blackButtonFrame3}
                    className={classNames(
                      projectcss.all,
                      sty.blackButtonFrame3,
                      {
                        [sty.blackButtonFrame3mode_signIn]: hasVariant(
                          $state,
                          "mode",
                          "signIn"
                        ),
                        [sty.blackButtonFrame3mode_signUp]: hasVariant(
                          $state,
                          "mode",
                          "signUp"
                        )
                      }
                    )}
                  />

                  <p.PlasmicImg
                    alt={""}
                    className={classNames(sty.img__uvjd8, {
                      [sty.imgmode_signUp__uvjd8DiTvY]: hasVariant(
                        $state,
                        "mode",
                        "signUp"
                      )
                    })}
                    displayHeight={"41.735px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"41.832px"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/72d9f11e78d27a9303ed2ed385b7c98b.svg",
                      fullWidth: 41.832,
                      fullHeight: 41.735,
                      aspectRatio: 1
                    }}
                  />
                </button>
              </p.Stack>
              <div
                data-plasmic-name={"space3"}
                data-plasmic-override={overrides.space3}
                className={classNames(projectcss.all, sty.space3, {
                  [sty.space3mode_signUp]: hasVariant($state, "mode", "signUp")
                })}
              />

              <div
                data-plasmic-name={
                  "dontLikePasswordsMaybeAPasswordManagerIsWhatYouNeedButYouCanAlso"
                }
                data-plasmic-override={
                  overrides.dontLikePasswordsMaybeAPasswordManagerIsWhatYouNeedButYouCanAlso
                }
                className={classNames(
                  projectcss.all,
                  sty.dontLikePasswordsMaybeAPasswordManagerIsWhatYouNeedButYouCanAlso,
                  {
                    [sty.dontLikePasswordsMaybeAPasswordManagerIsWhatYouNeedButYouCanAlsomode_magic]:
                      hasVariant($state, "mode", "magic"),
                    [sty.dontLikePasswordsMaybeAPasswordManagerIsWhatYouNeedButYouCanAlsomode_signUp]:
                      hasVariant($state, "mode", "signUp")
                  }
                )}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__idk5K,
                    {
                      [sty.textmode_magic__idk5Kz7Brm]: hasVariant(
                        $state,
                        "mode",
                        "magic"
                      ),
                      [sty.textmode_signUp__idk5KdiTvY]: hasVariant(
                        $state,
                        "mode",
                        "signUp"
                      )
                    }
                  )}
                >
                  {hasVariant($state, "mode", "signUp") ? (
                    <React.Fragment>
                      <React.Fragment>
                        {
                          "By clicking on 'Sign up' above, you are agreeing to the "
                        }
                      </React.Fragment>
                      {
                        <a
                          className={classNames(
                            projectcss.all,
                            projectcss.a,
                            projectcss.__wab_text,
                            projectcss.plasmic_default__inline,
                            sty.link__nHO,
                            {
                              [sty.linkmode_signUp__nHOdiTvY]: hasVariant(
                                $state,
                                "mode",
                                "signUp"
                              )
                            }
                          )}
                          href={"https://hubhub.app/terms-of-service"}
                        >
                          {hasVariant($state, "mode", "signUp") ? (
                            <React.Fragment>
                              <span
                                className={
                                  "plasmic_default__all plasmic_default__span"
                                }
                                style={{ color: "#5978E8" }}
                              >
                                {"Terms of Service"}
                              </span>
                            </React.Fragment>
                          ) : (
                            "Terms of Service"
                          )}
                        </a>
                      }
                      <React.Fragment>{" & "}</React.Fragment>
                      {
                        <a
                          className={classNames(
                            projectcss.all,
                            projectcss.a,
                            projectcss.__wab_text,
                            projectcss.plasmic_default__inline,
                            sty.link___7AsK,
                            {
                              [sty.linkmode_signUp___7AsKdiTvY]: hasVariant(
                                $state,
                                "mode",
                                "signUp"
                              )
                            }
                          )}
                          href={"https://hubhub.app/privacy-policy"}
                        >
                          {hasVariant($state, "mode", "signUp") ? (
                            <React.Fragment>
                              <span
                                className={
                                  "plasmic_default__all plasmic_default__span"
                                }
                                style={{ color: "#5978E8" }}
                              >
                                {"Privacy Policy"}
                              </span>
                            </React.Fragment>
                          ) : (
                            "Privacy Policy"
                          )}
                        </a>
                      }
                      <React.Fragment>{""}</React.Fragment>
                    </React.Fragment>
                  ) : (
                    "Don\u2019t like passwords? Maybe a password manager is what you need. But you can also..."
                  )}
                </div>
              </div>
              <div
                data-plasmic-name={"space4"}
                data-plasmic-override={overrides.space4}
                className={classNames(projectcss.all, sty.space4, {
                  [sty.space4mode_signUp]: hasVariant($state, "mode", "signUp")
                })}
              />

              <Button
                data-plasmic-name={"magicLinkSignInButton"}
                data-plasmic-override={overrides.magicLinkSignInButton}
                className={classNames(
                  "__wab_instance",
                  sty.magicLinkSignInButton,
                  {
                    [sty.magicLinkSignInButtonmode_magic]: hasVariant(
                      $state,
                      "mode",
                      "magic"
                    ),
                    [sty.magicLinkSignInButtonmode_signUp]: hasVariant(
                      $state,
                      "mode",
                      "signUp"
                    )
                  }
                )}
                color={"lightBlue"}
                size={"compact"}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__z6Wgu,
                    {
                      [sty.textmode_magic__z6Wguz7Brm]: hasVariant(
                        $state,
                        "mode",
                        "magic"
                      ),
                      [sty.textmode_signUp__z6WguDiTvY]: hasVariant(
                        $state,
                        "mode",
                        "signUp"
                      )
                    }
                  )}
                >
                  {hasVariant($state, "mode", "magic") ? (
                    "Use Password"
                  ) : hasVariant($state, "mode", "signUp") ? (
                    <React.Fragment>
                      <React.Fragment>{"Sign In "}</React.Fragment>
                      {
                        <span
                          data-plasmic-name={"span"}
                          data-plasmic-override={overrides.span}
                          className={classNames(
                            projectcss.all,
                            projectcss.span,
                            projectcss.__wab_text,
                            projectcss.plasmic_default__inline,
                            sty.span,
                            {
                              [sty.spanmode_signUp]: hasVariant(
                                $state,
                                "mode",
                                "signUp"
                              )
                            }
                          )}
                        >
                          {"via"}
                        </span>
                      }
                      <React.Fragment>
                        {" Magic Link \ud83d\udce8"}
                      </React.Fragment>
                    </React.Fragment>
                  ) : (
                    "Sign In via Magic Link \ud83d\udce8"
                  )}
                </div>
              </Button>
              {(hasVariant($state, "mode", "signUp") ? false : true) ? (
                <div
                  data-plasmic-name={"resetPassword"}
                  data-plasmic-override={overrides.resetPassword}
                  className={classNames(projectcss.all, sty.resetPassword, {
                    [sty.resetPasswordmode_signUp]: hasVariant(
                      $state,
                      "mode",
                      "signUp"
                    )
                  })}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__cjuw2
                    )}
                  >
                    {"_"}
                  </div>
                  <div
                    data-plasmic-name={"andIfYouNeedToYouCan"}
                    data-plasmic-override={overrides.andIfYouNeedToYouCan}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.andIfYouNeedToYouCan,
                      {
                        [sty.andIfYouNeedToYouCanmode_signIn]: hasVariant(
                          $state,
                          "mode",
                          "signIn"
                        ),
                        [sty.andIfYouNeedToYouCanmode_signUp]: hasVariant(
                          $state,
                          "mode",
                          "signUp"
                        )
                      }
                    )}
                  >
                    {"And if you need to, you can "}
                  </div>
                  <a
                    data-plasmic-name={"resetPasswordButton"}
                    data-plasmic-override={overrides.resetPasswordButton}
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      sty.resetPasswordButton,
                      {
                        [sty.resetPasswordButtonmode_signIn]: hasVariant(
                          $state,
                          "mode",
                          "signIn"
                        )
                      }
                    )}
                    href={
                      hasVariant($state, "mode", "signIn")
                        ? "/reset-password"
                        : undefined
                    }
                  >
                    {"reset your password"}
                  </a>
                </div>
              ) : null}
              {(hasVariant($state, "mode", "signUp") ? true : false) ? (
                <div
                  data-plasmic-name={"signInContainer"}
                  data-plasmic-override={overrides.signInContainer}
                  className={classNames(projectcss.all, sty.signInContainer, {
                    [sty.signInContainermode_signUp]: hasVariant(
                      $state,
                      "mode",
                      "signUp"
                    )
                  })}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__mfobx
                    )}
                  >
                    {"_"}
                  </div>
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__u185V, {
                      [sty.freeBoxmode_signUp__u185VDiTvY]: hasVariant(
                        $state,
                        "mode",
                        "signUp"
                      )
                    })}
                  >
                    <div
                      data-plasmic-name={"andIfYouNeedToYouCan2"}
                      data-plasmic-override={overrides.andIfYouNeedToYouCan2}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.andIfYouNeedToYouCan2,
                        {
                          [sty.andIfYouNeedToYouCan2mode_signUp]: hasVariant(
                            $state,
                            "mode",
                            "signUp"
                          )
                        }
                      )}
                    >
                      {"Already have an account?"}
                    </div>
                    <a
                      data-plasmic-name={"resetPasswordButton2"}
                      data-plasmic-override={overrides.resetPasswordButton2}
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        sty.resetPasswordButton2
                      )}
                      href={(() => {
                        try {
                          return $props.authUrl;
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return "/signin";
                          }
                          throw e;
                        }
                      })()}
                    >
                      {"Sign In"}
                    </a>
                  </p.Stack>
                </div>
              ) : null}
              <div
                data-plasmic-name={"space5"}
                data-plasmic-override={overrides.space5}
                className={classNames(projectcss.all, sty.space5, {
                  [sty.space5mode_signUp]: hasVariant($state, "mode", "signUp")
                })}
              />
            </p.Stack>
          </div>
          <p.Stack
            as={"div"}
            data-plasmic-name={"bottom"}
            data-plasmic-override={overrides.bottom}
            hasGap={true}
            className={classNames(
              projectcss.all,
              sty.bottom,
              hasVariant($state, "mode", "signUp")
                ? "dark-linear-background"
                : undefined,
              {
                [sty.bottomapp_hubHub]: hasVariant($state, "app", "hubHub"),
                [sty.bottommode_signIn]: hasVariant($state, "mode", "signIn"),
                [sty.bottommode_signUp]: hasVariant($state, "mode", "signUp")
              }
            )}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__qFl8Y,
                {
                  [sty.textmode_signIn__qFl8Yamtuw]: hasVariant(
                    $state,
                    "mode",
                    "signIn"
                  ),
                  [sty.textmode_signUp__qFl8YdiTvY]: hasVariant(
                    $state,
                    "mode",
                    "signUp"
                  )
                }
              )}
            >
              {hasVariant($state, "mode", "signUp")
                ? "To dip your toes in the water, you can also:"
                : "or if you haven\u2019t already"}
            </div>
            {(hasVariant($state, "mode", "signUp") ? false : true) ? (
              <div
                data-plasmic-name={"orSignUpButton"}
                data-plasmic-override={overrides.orSignUpButton}
                className={classNames(projectcss.all, sty.orSignUpButton, {
                  [sty.orSignUpButtonapp_hubHub]: hasVariant(
                    $state,
                    "app",
                    "hubHub"
                  ),
                  [sty.orSignUpButtonmode_signIn]: hasVariant(
                    $state,
                    "mode",
                    "signIn"
                  ),
                  [sty.orSignUpButtonmode_signUp]: hasVariant(
                    $state,
                    "mode",
                    "signUp"
                  )
                })}
                onClick={async event => {
                  const $steps = {};

                  $steps["goToPage"] = true
                    ? (() => {
                        const actionArgs = {
                          destination: (() => {
                            try {
                              return $props.authUrl;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return "/signup";
                              }
                              throw e;
                            }
                          })()
                        };
                        return (({ destination }) => {
                          if (
                            typeof destination === "string" &&
                            destination.startsWith("#")
                          ) {
                            document
                              .getElementById(destination.substr(1))
                              .scrollIntoView({ behavior: "smooth" });
                          } else {
                            location.assign(destination);
                          }
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["goToPage"] != null &&
                    typeof $steps["goToPage"] === "object" &&
                    typeof $steps["goToPage"].then === "function"
                  ) {
                    $steps["goToPage"] = await $steps["goToPage"];
                  }
                }}
              >
                <div className={classNames(projectcss.all, sty.freeBox__vaOmp)}>
                  <ArrowReply24FilledIcon
                    className={classNames(projectcss.all, sty.svg__kcgj3)}
                    role={"img"}
                  />
                </div>
                <p.Stack
                  as={"div"}
                  data-plasmic-name={"buttonDefault"}
                  data-plasmic-override={overrides.buttonDefault}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.buttonDefault, {
                    [sty.buttonDefaultmode_signIn]: hasVariant(
                      $state,
                      "mode",
                      "signIn"
                    ),
                    [sty.buttonDefaultmode_signUp]: hasVariant(
                      $state,
                      "mode",
                      "signUp"
                    )
                  })}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__x6Wea,
                      {
                        [sty.textapp_hubHub__x6Wea3NElu]: hasVariant(
                          $state,
                          "app",
                          "hubHub"
                        ),
                        [sty.textmode_signIn__x6WeaAmtuw]: hasVariant(
                          $state,
                          "mode",
                          "signIn"
                        ),
                        [sty.textmode_signUp__x6WeaDiTvY]: hasVariant(
                          $state,
                          "mode",
                          "signUp"
                        )
                      }
                    )}
                  >
                    {"Sign Up"}
                  </div>
                </p.Stack>
              </div>
            ) : null}
            <Button
              data-plasmic-name={"continueWithoutAnAccountButton"}
              data-plasmic-override={overrides.continueWithoutAnAccountButton}
              className={classNames(
                "__wab_instance",
                sty.continueWithoutAnAccountButton,
                {
                  [sty.continueWithoutAnAccountButtonmode_signUp]: hasVariant(
                    $state,
                    "mode",
                    "signUp"
                  )
                }
              )}
              color={"lightBlue"}
              size={"compact"}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__u0L71
                )}
              >
                {"Continue without an account"}
              </div>
            </Button>
          </p.Stack>
        </p.Stack>
      </p.Stack>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "container",
    "logoAndText",
    "logo",
    "form",
    "top",
    "proProLabel",
    "topContent",
    "space",
    "loginTable",
    "nameField",
    "nameInput",
    "emailField",
    "emailInput",
    "passwordField",
    "passwordInput",
    "signInButton",
    "space2",
    "orSignUpSignInWithOneOfTheseSocialNetworks",
    "signInPlatformsButtons",
    "facebookAuthButton",
    "blackButtonFrame",
    "iconSourcesFacebook",
    "xcomAuthButton",
    "blackButtonFrame2",
    "googleAuthButton",
    "blackButtonFrame3",
    "space3",
    "dontLikePasswordsMaybeAPasswordManagerIsWhatYouNeedButYouCanAlso",
    "space4",
    "magicLinkSignInButton",
    "span",
    "resetPassword",
    "andIfYouNeedToYouCan",
    "resetPasswordButton",
    "signInContainer",
    "andIfYouNeedToYouCan2",
    "resetPasswordButton2",
    "space5",
    "bottom",
    "orSignUpButton",
    "buttonDefault",
    "continueWithoutAnAccountButton"
  ],
  container: [
    "container",
    "logoAndText",
    "logo",
    "form",
    "top",
    "proProLabel",
    "topContent",
    "space",
    "loginTable",
    "nameField",
    "nameInput",
    "emailField",
    "emailInput",
    "passwordField",
    "passwordInput",
    "signInButton",
    "space2",
    "orSignUpSignInWithOneOfTheseSocialNetworks",
    "signInPlatformsButtons",
    "facebookAuthButton",
    "blackButtonFrame",
    "iconSourcesFacebook",
    "xcomAuthButton",
    "blackButtonFrame2",
    "googleAuthButton",
    "blackButtonFrame3",
    "space3",
    "dontLikePasswordsMaybeAPasswordManagerIsWhatYouNeedButYouCanAlso",
    "space4",
    "magicLinkSignInButton",
    "span",
    "resetPassword",
    "andIfYouNeedToYouCan",
    "resetPasswordButton",
    "signInContainer",
    "andIfYouNeedToYouCan2",
    "resetPasswordButton2",
    "space5",
    "bottom",
    "orSignUpButton",
    "buttonDefault",
    "continueWithoutAnAccountButton"
  ],
  logoAndText: ["logoAndText", "logo"],
  logo: ["logo"],
  form: [
    "form",
    "top",
    "proProLabel",
    "topContent",
    "space",
    "loginTable",
    "nameField",
    "nameInput",
    "emailField",
    "emailInput",
    "passwordField",
    "passwordInput",
    "signInButton",
    "space2",
    "orSignUpSignInWithOneOfTheseSocialNetworks",
    "signInPlatformsButtons",
    "facebookAuthButton",
    "blackButtonFrame",
    "iconSourcesFacebook",
    "xcomAuthButton",
    "blackButtonFrame2",
    "googleAuthButton",
    "blackButtonFrame3",
    "space3",
    "dontLikePasswordsMaybeAPasswordManagerIsWhatYouNeedButYouCanAlso",
    "space4",
    "magicLinkSignInButton",
    "span",
    "resetPassword",
    "andIfYouNeedToYouCan",
    "resetPasswordButton",
    "signInContainer",
    "andIfYouNeedToYouCan2",
    "resetPasswordButton2",
    "space5",
    "bottom",
    "orSignUpButton",
    "buttonDefault",
    "continueWithoutAnAccountButton"
  ],
  top: [
    "top",
    "proProLabel",
    "topContent",
    "space",
    "loginTable",
    "nameField",
    "nameInput",
    "emailField",
    "emailInput",
    "passwordField",
    "passwordInput",
    "signInButton",
    "space2",
    "orSignUpSignInWithOneOfTheseSocialNetworks",
    "signInPlatformsButtons",
    "facebookAuthButton",
    "blackButtonFrame",
    "iconSourcesFacebook",
    "xcomAuthButton",
    "blackButtonFrame2",
    "googleAuthButton",
    "blackButtonFrame3",
    "space3",
    "dontLikePasswordsMaybeAPasswordManagerIsWhatYouNeedButYouCanAlso",
    "space4",
    "magicLinkSignInButton",
    "span",
    "resetPassword",
    "andIfYouNeedToYouCan",
    "resetPasswordButton",
    "signInContainer",
    "andIfYouNeedToYouCan2",
    "resetPasswordButton2",
    "space5"
  ],
  proProLabel: ["proProLabel"],
  topContent: [
    "topContent",
    "space",
    "loginTable",
    "nameField",
    "nameInput",
    "emailField",
    "emailInput",
    "passwordField",
    "passwordInput",
    "signInButton",
    "space2",
    "orSignUpSignInWithOneOfTheseSocialNetworks",
    "signInPlatformsButtons",
    "facebookAuthButton",
    "blackButtonFrame",
    "iconSourcesFacebook",
    "xcomAuthButton",
    "blackButtonFrame2",
    "googleAuthButton",
    "blackButtonFrame3",
    "space3",
    "dontLikePasswordsMaybeAPasswordManagerIsWhatYouNeedButYouCanAlso",
    "space4",
    "magicLinkSignInButton",
    "span",
    "resetPassword",
    "andIfYouNeedToYouCan",
    "resetPasswordButton",
    "signInContainer",
    "andIfYouNeedToYouCan2",
    "resetPasswordButton2",
    "space5"
  ],
  space: ["space"],
  loginTable: [
    "loginTable",
    "nameField",
    "nameInput",
    "emailField",
    "emailInput",
    "passwordField",
    "passwordInput",
    "signInButton"
  ],
  nameField: ["nameField", "nameInput"],
  nameInput: ["nameInput"],
  emailField: ["emailField", "emailInput"],
  emailInput: ["emailInput"],
  passwordField: ["passwordField", "passwordInput"],
  passwordInput: ["passwordInput"],
  signInButton: ["signInButton"],
  space2: ["space2"],
  orSignUpSignInWithOneOfTheseSocialNetworks: [
    "orSignUpSignInWithOneOfTheseSocialNetworks"
  ],
  signInPlatformsButtons: [
    "signInPlatformsButtons",
    "facebookAuthButton",
    "blackButtonFrame",
    "iconSourcesFacebook",
    "xcomAuthButton",
    "blackButtonFrame2",
    "googleAuthButton",
    "blackButtonFrame3"
  ],
  facebookAuthButton: [
    "facebookAuthButton",
    "blackButtonFrame",
    "iconSourcesFacebook"
  ],
  blackButtonFrame: ["blackButtonFrame"],
  iconSourcesFacebook: ["iconSourcesFacebook"],
  xcomAuthButton: ["xcomAuthButton", "blackButtonFrame2"],
  blackButtonFrame2: ["blackButtonFrame2"],
  googleAuthButton: ["googleAuthButton", "blackButtonFrame3"],
  blackButtonFrame3: ["blackButtonFrame3"],
  space3: ["space3"],
  dontLikePasswordsMaybeAPasswordManagerIsWhatYouNeedButYouCanAlso: [
    "dontLikePasswordsMaybeAPasswordManagerIsWhatYouNeedButYouCanAlso"
  ],
  space4: ["space4"],
  magicLinkSignInButton: ["magicLinkSignInButton", "span"],
  span: ["span"],
  resetPassword: [
    "resetPassword",
    "andIfYouNeedToYouCan",
    "resetPasswordButton"
  ],
  andIfYouNeedToYouCan: ["andIfYouNeedToYouCan"],
  resetPasswordButton: ["resetPasswordButton"],
  signInContainer: [
    "signInContainer",
    "andIfYouNeedToYouCan2",
    "resetPasswordButton2"
  ],
  andIfYouNeedToYouCan2: ["andIfYouNeedToYouCan2"],
  resetPasswordButton2: ["resetPasswordButton2"],
  space5: ["space5"],
  bottom: [
    "bottom",
    "orSignUpButton",
    "buttonDefault",
    "continueWithoutAnAccountButton"
  ],
  orSignUpButton: ["orSignUpButton", "buttonDefault"],
  buttonDefault: ["buttonDefault"],
  continueWithoutAnAccountButton: ["continueWithoutAnAccountButton"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  container: "div";
  logoAndText: "div";
  logo: typeof Logo;
  form: "div";
  top: "div";
  proProLabel: "div";
  topContent: "div";
  space: "div";
  loginTable: "form";
  nameField: "div";
  nameInput: typeof TextInput;
  emailField: "div";
  emailInput: typeof TextInput;
  passwordField: "div";
  passwordInput: typeof TextInput;
  signInButton: typeof Button;
  space2: "div";
  orSignUpSignInWithOneOfTheseSocialNetworks: "div";
  signInPlatformsButtons: "div";
  facebookAuthButton: "button";
  blackButtonFrame: "div";
  iconSourcesFacebook: "div";
  xcomAuthButton: "button";
  blackButtonFrame2: "div";
  googleAuthButton: "button";
  blackButtonFrame3: "div";
  space3: "div";
  dontLikePasswordsMaybeAPasswordManagerIsWhatYouNeedButYouCanAlso: "div";
  space4: "div";
  magicLinkSignInButton: typeof Button;
  span: "span";
  resetPassword: "div";
  andIfYouNeedToYouCan: "div";
  resetPasswordButton: "a";
  signInContainer: "div";
  andIfYouNeedToYouCan2: "div";
  resetPasswordButton2: "a";
  space5: "div";
  bottom: "div";
  orSignUpButton: "div";
  buttonDefault: "div";
  continueWithoutAnAccountButton: typeof Button;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSignInSignUpForm__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSignInSignUpForm__VariantsArgs;
    args?: PlasmicSignInSignUpForm__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicSignInSignUpForm__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicSignInSignUpForm__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSignInSignUpForm__ArgProps,
          internalVariantPropNames: PlasmicSignInSignUpForm__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSignInSignUpForm__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSignInSignUpForm";
  } else {
    func.displayName = `PlasmicSignInSignUpForm.${nodeName}`;
  }
  return func;
}

export const PlasmicSignInSignUpForm = Object.assign(
  // Top-level PlasmicSignInSignUpForm renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    container: makeNodeComponent("container"),
    logoAndText: makeNodeComponent("logoAndText"),
    logo: makeNodeComponent("logo"),
    form: makeNodeComponent("form"),
    top: makeNodeComponent("top"),
    proProLabel: makeNodeComponent("proProLabel"),
    topContent: makeNodeComponent("topContent"),
    space: makeNodeComponent("space"),
    loginTable: makeNodeComponent("loginTable"),
    nameField: makeNodeComponent("nameField"),
    nameInput: makeNodeComponent("nameInput"),
    emailField: makeNodeComponent("emailField"),
    emailInput: makeNodeComponent("emailInput"),
    passwordField: makeNodeComponent("passwordField"),
    passwordInput: makeNodeComponent("passwordInput"),
    signInButton: makeNodeComponent("signInButton"),
    space2: makeNodeComponent("space2"),
    orSignUpSignInWithOneOfTheseSocialNetworks: makeNodeComponent(
      "orSignUpSignInWithOneOfTheseSocialNetworks"
    ),
    signInPlatformsButtons: makeNodeComponent("signInPlatformsButtons"),
    facebookAuthButton: makeNodeComponent("facebookAuthButton"),
    blackButtonFrame: makeNodeComponent("blackButtonFrame"),
    iconSourcesFacebook: makeNodeComponent("iconSourcesFacebook"),
    xcomAuthButton: makeNodeComponent("xcomAuthButton"),
    blackButtonFrame2: makeNodeComponent("blackButtonFrame2"),
    googleAuthButton: makeNodeComponent("googleAuthButton"),
    blackButtonFrame3: makeNodeComponent("blackButtonFrame3"),
    space3: makeNodeComponent("space3"),
    dontLikePasswordsMaybeAPasswordManagerIsWhatYouNeedButYouCanAlso:
      makeNodeComponent(
        "dontLikePasswordsMaybeAPasswordManagerIsWhatYouNeedButYouCanAlso"
      ),
    space4: makeNodeComponent("space4"),
    magicLinkSignInButton: makeNodeComponent("magicLinkSignInButton"),
    span: makeNodeComponent("span"),
    resetPassword: makeNodeComponent("resetPassword"),
    andIfYouNeedToYouCan: makeNodeComponent("andIfYouNeedToYouCan"),
    resetPasswordButton: makeNodeComponent("resetPasswordButton"),
    signInContainer: makeNodeComponent("signInContainer"),
    andIfYouNeedToYouCan2: makeNodeComponent("andIfYouNeedToYouCan2"),
    resetPasswordButton2: makeNodeComponent("resetPasswordButton2"),
    space5: makeNodeComponent("space5"),
    bottom: makeNodeComponent("bottom"),
    orSignUpButton: makeNodeComponent("orSignUpButton"),
    buttonDefault: makeNodeComponent("buttonDefault"),
    continueWithoutAnAccountButton: makeNodeComponent(
      "continueWithoutAnAccountButton"
    ),

    // Metadata about props expected for PlasmicSignInSignUpForm
    internalVariantProps: PlasmicSignInSignUpForm__VariantProps,
    internalArgProps: PlasmicSignInSignUpForm__ArgProps
  }
);

export default PlasmicSignInSignUpForm;
/* prettier-ignore-end */
